import { ProfileType } from '../common/profile/enums';

export const RECORD_COMBINE_EVENT_PROFILE_TYPES: ProfileType[] = [
  ProfileType.school,
  ProfileType.teacher,
  ProfileType.parent,
  ProfileType.student
];

export const RECORD_COMBINE_EVENT_PROFILE_TYPES_NAME: Map<ProfileType, string> = new Map([
  [ProfileType.school, 'Оператор школы'],
  [ProfileType.teacher, 'Учитель'],
  [ProfileType.parent, 'Родитель'],
  [ProfileType.student, 'Студент']
]);

export enum VerificationTypes {
  withPhoto = 'withPhoto',
  withoutPhoto = 'withoutPhoto'
}

export const RECORD_VERIFICATION_TYPES: VerificationTypes[] = [
    VerificationTypes.withPhoto,
    VerificationTypes.withoutPhoto
];

export const RECORD_VERIFICATION_TYPES_NAME: Map<VerificationTypes, string> = new Map([
    [VerificationTypes.withPhoto, 'с фото'],
    [VerificationTypes.withoutPhoto, 'без фото'],
]);